module.exports = __webpack_public_path__ + "static/media/joe-gardner-1.55217daf.jpg";